/*
 * @Author: JamesWong
 * @Description: 首页英文
 * @Date: 2018-11-29 10:34:46
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2020-04-13 13:13:48
 */

export default {
  productName: 'Xiniu EPOS Company Management System',
  companyNo: 'Company No.',
  companyEnterTips: 'Please enter company No.',
  account: 'Account',
  accountEnterTips: 'Enter account',
  password: 'Password',
  passwordEnterTips: 'Enter password',
  login: 'Login',
  '剩余天数': '，Days left',
  Logout: 'Logout',
  backHome: 'Back to Home',
  openedService: 'Opened service',
  sellModel: 'sell model',
  foundational: 'Foundational In&Out',
  appVersion: 'Application Version',
  authChannel: 'Authorized Channel',
  allAuthChannel: 'Total Authorized Channel Number',
  authWarehouse: 'Warehouse Permit',
  authMumber: 'Authorized Number',
  remainAuthNum: 'Remain Available Authorization Number',
  whalesaleSelected: 'WholesaleRetail Selection',
  deviceActivateManagement: 'Device Activate',
  subScreen: 'Sub-screen Set',
  displayMode: 'Display Mode',
  rollingDisplay: 'Rolling display Photos',
  advertisementVideo: 'Advertisement Video',
  ticketDisposition: 'Ticket Disposition',
  selfcashierDisposition: 'Self-cashier Set',
  onlinePayDisposition: 'Online-Pay set',
  accountModule: 'Account',
  foundationalSet: 'In&Out Model Disposition',
  depositReceipt: 'Deposit Receipt Set',
  loginNumTips: 'Company No. cannot be empty!',
  loginAccountTips: 'Login Account cannot be empty!',
  alipayCall: 'Authorized, pls check on Xiniu EPOS Management System',
  noSet: 'Not set, logistic function cannot normally use',
  storeAuthorizaedManage: 'Channel Permit',
  manageAllFacility: 'Device Binding',
  authorizedMessage: 'Authory-Info',
  '收银模块': 'Sale',
  '物流模块': 'In&Out',
  '其他': 'other',
  record: 'Login Record',
  changeLog: '',
  'deviceChangeLog': 'Change Record',
  'deviceUntiedLog': 'Unbundling Record',
  'Web端使用ERP物流模块': 'WebPOS Using ERP Logistics Module',
  collaboraivePlatformSet: 'Collaborative Platform Setting',
  styleTicketManager: 'Document Printing Style Manager',
  '查看合同': 'Check Contract'
}



// WEBPACK FOOTER //
// ./src/i18n/en/main.js